import { z } from "zod/v4";
import {
  createOverviewSearchSchema,
  overviewFilterValues,
} from "#/modules/util.overview/schema.search";

/**
 * Search params schema for the users admin overview: searchTerm, sort, has2FaEnabled filter
 * ("true"/"false" values), pagination.
 */
const usersAdmin = createOverviewSearchSchema({
  orderBy: "createdAt",
  orderDirection: "descending",
  extra: {
    has2FaEnabled: overviewFilterValues(),
  },
});

export const usersAdminSearchSchema = usersAdmin.schema;

/** Defaults stripped from the URL by `stripSearchParams`. */
export const USERS_ADMIN_SEARCH_DEFAULTS = usersAdmin.defaults;

export type UsersAdminSearch = z.infer<typeof usersAdminSearchSchema>;
